import { MUITab } from "@abb/arcadia-ui-react"
import { useEffect, useState } from "react"
import { Navigate, useNavigate, useParams } from "react-router-dom"
import { useHashTab } from "../../../../hooks/useHashTab"
import { digitalManagerApi } from "../../../../services/api"
import {
  DiMaDetailsHeader,
  DiMaDetailsHeaderProps,
} from "../../../components/DiMaDetailsHeader"
import { DiMaProgress } from "../../../components/DiMaProgress"
import { DeviceGet } from "../../../models/Device"
import { DeviceDetails } from "./details_tab/DeviceDetails"
import { DeviceRoles } from "./roles_tab/DeviceRoles"
import { DeviceSoftwarePackageFirmwareConstraints } from "./software_package_firmware_constraints_tab/DeviceSoftwarePackageFirmwareConstraints"

const returnURL = "/devices"

export function DeviceContainer() {
  const { deviceId } = useParams()
  const navigate = useNavigate()
  const { activeTab, handleTabChange } = useHashTab("details")

  const [device, setDevice] = useState<DeviceGet>()

  useEffect(() => {
    if (deviceId) {
      digitalManagerApi
        .get<DeviceGet>(`/devices/${deviceId}`)
        .then((res) => {
          setDevice(res.data)
        })
        .catch(() => {
          navigate(returnURL)
        })
    }
  }, [deviceId, navigate])

  if (!deviceId) {
    return <Navigate to={returnURL} />
  }

  if (!device) {
    return <DiMaProgress />
  }

  const detailsHeaderProps: DiMaDetailsHeaderProps = {
    url: returnURL,
    title: device.name,
    label: "Device",
    subtitle: device.family.name,
    hideCopyToClipboard: true,
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", flexGrow: 1 }}>
      <DiMaDetailsHeader {...detailsHeaderProps} />
      <MUITab
        tabItems={[
          { id: "details", label: "Details" },
          { id: "roles", label: "Roles" },
          {
            id: "software-package-firmware-constraints",
            label: "SW Package FW Constraints",
          },
        ]}
        value={activeTab}
        handleChange={handleTabChange}
      />

      {activeTab === "details" && <DeviceDetails device={device} setDevice={setDevice} />}

      {activeTab === "roles" && <DeviceRoles />}

      {activeTab === "software-package-firmware-constraints" && (
        <DeviceSoftwarePackageFirmwareConstraints />
      )}
    </div>
  )
}
